"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27.61 32", width: "1em", height: "1em", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.151 22.783c0-.185-.037-.33-.112-.434s-.186-.184-.335-.237c-.09-.035-.215-.054-.373-.058s-.37-.006-.636-.006h-.274v1.5h.08c.388 0 .656-.003.805-.008.149-.005.3-.042.454-.109a.59.59 0 00.297-.259.797.797 0 00.094-.389zm.278 2.879c0-.202-.043-.36-.13-.475a.782.782 0 00-.389-.259 1.43 1.43 0 00-.433-.064c-.184-.004-.43-.007-.738-.007h-.318v1.639h.093c.45 0 .762-.003.935-.009.173-.006.349-.045.527-.119a.683.683 0 00.345-.283.824.824 0 00.108-.423zm1.781.031c0 .325-.065.611-.194.857-.13.246-.304.45-.523.611a2.479 2.479 0 01-.854.413c-.31.082-.704.123-1.182.123H.9a.2.2 0 01-.2-.2v-6.44c0-.11.09-.2.2-.2h3.411c1.323 0 1.56 1.095 1.56 1.817 0 1.156-.77 1.285-1.066 1.402v.035c.426.085.767.259 1.023.521.254.262.382.616.382 1.061zm-2.454-9.372l-.668-2.158-.668 2.158h1.336zM.003 19.003l2.21-6.7h1.793l2.21 6.7H4.525l-.409-1.44H2.06l-.409 1.44H.003zm2.238-8.156v-5H0V4.303h6.12v1.543H3.885v5H2.241zm10.369 15.85h-2v-21h17v1h-15v3h15v1h-15v3h15v1h-15v3h15v1h-15v3h15v1h-15v3h15v1h-15z" })));
};
var SvgTablature = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgTablature;
var templateObject_1;
